var host = "https://api-unwmn.bitflex.xyz/api";

const { h } = require("vue");

module.exports = {
    V1API: {
        // RDRC
        'getAccessToken': host + '/auth/token',
        'refreshAccessToken': host + '/authentication/token/refresh',
        'verifyLogin': host + '/auth/token/verify',

        // Dashboard
        'get_dashboard_count': host + '/count/',

        // Experience
        'experience_list': host + '/experience/list',
        'create_experience': host + '/experience/create',
        'update_experience': host + '/experience/update/',
        'delete_experience': host + '/experience/delete/',

        // student submission
        'form_submission_list': host + '/form/list',
        'form_submission_details': host + '/form/detail/',
        'delete_submission': host + '/form/delete/',

        // Gallery
        'gallery_list': host + '/gallery/list',
        'create_gallery': host + '/gallery/create',
        'get_gallery_details': host + '/gallery/detail/',
        'update_gallery': host + '/gallery/update/',
        'gallery_delete': host + '/gallery/delete/',

        // Stories
        'story_list': host + '/stories/list',
        'create_story': host + '/stories/create',
        'get_story_details': host + '/stories/detail/',
        'update_story': host + '/stories/update/',
        'story_delete': host + '/stories/delete/',

        // Location
        'location_list': host + '/location/',











        // Team
        'team_list': host + '/team/',
        'create_team': host + '/team/create',
        'update_team': host + '/team/update/',
        'delete_team': host + '/team/delete/',
        'update_team_serial': host + '/team/serial-update/',

        // Partner
        'partner_list': host + '/partner/',
        'create_partner': host + '/partner/create',
        'update_partner': host + '/partner/edit/',
        'delete_partner': host + '/partner/delete/',

        // Banner
        'get_banner': host + '/banner/',
        'create_banner': host + '/banner/create',

        // About
        'get_about': host + '/aboutus/view',
        'create_about': host + '/aboutus/create',

        // Involvement
        'get_involvement': host + '/involvement/',
        'create_involvement': host + '/involvement/create',

        // Setting
        'get_setting': host + '/setting/view',
        'create_setting': host + '/setting/create',

        // Policy
        'policy_list': host + '/policy/',
        'create_policy': host + '/policy/create',
        'update_policy': host + '/policy/edit/',
        'delete_policy': host + '/policy/delete/',

        // Contact
        'contact_list': host + '/contact/',
        'delete_contact': host + '/contact/delete/',

        // Subscriber
        'get_subscriber': host + '/subscriber/',
        'delete_subscriber': host + '/subscriber/delete/',

        // Notice
        'notice_list': host + '/notice/',
        'create_notice': host + '/notice/create',
        'update_notice': host + '/notice/edit/',
        'delete_notice': host + '/notice/delete/',

        // Expertise
        'expertise_list': host + '/expertise/list',
        'create_expertise': host + '/expertise/create',
        'update_expertise': host + '/expertise/update/',
        'delete_expertise': host + '/expertise/delete/',
        'get_expertise_details': host + '/expertise/detail/',

        // CoProduction Lab
        'production_list': host + '/lab/list',
        'create_production': host + '/lab/create',
        'update_production': host + '/lab/update/',
        'delete_production': host + '/lab/delete/',
        'get_production_details': host + '/lab/detail/',

        // News
        'news_list': host + '/news/',
        'create_news': host + '/news/create',
        'update_news': host + '/news/update/',
        'delete_news': host + '/news/delete/',
        'toggle_news_featured': host + '/news/featured/toggle/',
        'get_news_details': host + '/news/detail/',

        // Research --> List
        'research_list': host + '/research/list',
        'create_research': host + '/research/create',
        'update_research': host + '/research/update/',
        'delete_research': host + '/research/delete/',
        'toggle_research_featured': host + '/research/featured/toggle/',
        'get_research_details': host + '/research/detail/',
        'update_research_serial': host + '/research/serial-update/',

        // Research --> Category
        'research_category_list': host + '/research/category',
        'create_research_category': host + '/research/category/create',
        'delete_research_category': host + '/research/category/delete/',

        // Publication --> List
        'publication_list': host + '/publications/',
        'create_publication': host + '/publications/create',
        'update_publication': host + '/publications/update/',
        'delete_publication': host + '/publications/delete/',
        'toggle_publication_featured': host + '/publications/featured/toggle/',
        'update_pub_serial': host + '/publications/serial-update/',

        // Publication --> Category
        'publication_category_list': host + '/publications/category',
        'create_publication_category': host + '/publications/category/create',
        'delete_publication_category': host + '/publications/category/delete/',

        // Advocacy --> List
        'advocacy_list': host + '/advocacy/list',
        'create_advocacy': host + '/advocacy/create',
        'update_advocacy': host + '/advocacy/update/',
        'delete_advocacy': host + '/advocacy/delete/',
        'toggle_advocacy_featured': host + '/advocacy/featured/toggle/',
        'get_advocacy_details': host + '/advocacy/detail/',

        // Advocacy --> Category
        'advocacy_category_list': host + '/advocacy/category',
        'create_advocacy_category': host + '/advocacy/category/create',
        'delete_advocacy_category': host + '/advocacy/category/delete/',

        // Job
        'job_list': host + '/job/',
        'create_job': host + '/job/create',
        'update_job': host + '/job/update/',
        'delete_job': host + '/job/delete/',
        'job_detail': host + '/job/details/',
        'toggle_job_open': host + '/job/opened/toggle/',

        // Applicant
        'applicant_list': host + '/job/apply/list',
        'delete_applicant': host + '/job/apply/delete/',

        // Content
        'create_content':host+'/content/create',
        'update_content':host+'/content/update/',
        'content_list':host+'/content/',
        'content_delete':host+'/content/delete/',
        'get_content_details':host+'/content/detail/',
        'get_content_by_type_slug':host+'/content/by-type-slug/',
        'get_content_by_type':host+'/content/by-type/',




        // Package
        'package_list': host + '/subscription/admin-site/pack/admin-list',
        'create_package': host + '/subscription/pack/create',
        'update_package': host + '/subscription/pack/edit/',
        'package_delete': host + '/subscription/pack/delete/',

        // Coupon
        'coupon_list': host + '/coupons/',
        'create_coupon': host + '/coupons/create',
        'update_coupon': host + '/coupons/update/',
        'coupon_delete': host + '/coupons/delete/',

        // Coin
        'coin_list': host + '/coin-wallet/feature-costs/dash',
        'create_coin': host + '/coin-wallet/feature-costs/create',
        'update_coin': host + '/coin-wallet/feature-costs/edit/',
        'coin_delete': host + '/coin-wallet/feature-costs/delete/',

        // Subscriber
        'subscriber_list': host + '/dashboard/regular-premium/list',
        'payment_initiated_list': host + '/dashboard/unpaid/list',
        'expiring_soon_list': host + '/dashboard/expiring-subscription/list',
        'activated_list': host + '/dashboard/paid-active/list',
        'expired_list': host + '/dashboard/expired/list',
        'subscriber_history': host + '/dashboard/user/wallet-history',
        // 'subscriber_delete': host + '/coupons/delete/',

        // Payment Log
        'payment_log_list': host + '/dashboard/payment-log/list',
        'payment_details': host + '/location/shelter/details/',
        'create_payment': host + '/location/shelter/create',
        'update_payment': host + '/location/shelter/edit/',
        'payment_delete': host + '/location/shelter/delete/',

        // Volunteer
        'volunteer_list': host + '/volunteer/accounts/list',
        'create_volunteer': host + '/volunteer/accounts/create',
        'update_volunteer': host + '/volunteer/accounts/edit/full/',
        'volunteer_delete': host + '/access-control/user-accounts/delete/',

        // House
        'house_list': host + '/home/list/admin-panel/full-list',
        'create_house': host + '/home/register',
        'other_member_delete': host + '/home/delete-listed/other-members',
        'other_member_edit': host + '/home/update-information/other-member/',
        'core_member_edit': host + '/home/update-information/core-member/',

        // Emergency Contact
        'contact_list1': host + '/resource/contact',
        'create_contact': host + '/resource/contact/create',
        'update_contact': host + '/resource/contact/edit/',
        'contact_delete1': host + '/resource/contact/delete/',

        // Relief
        'relief_list': host + '/resource/relief',
        'create_relief': host + '/resource/relief/create',
        'update_relief': host + '/resource/relief/edit/',
        'relief_delete': host + '/resource/relief/delete/',

        // Occupancy Summary
        'occupancy_summary_list': host + '/disaster-occupancy/all/sorted',

        //Portfolio
        // Blog
        'blog_list':host+'/blog/list',
        'create_blog':host+'/blog/create',
        'get_blog_details':host+'/blog/getdetail/slug',
        'update_blog':host+'/blog/update/',
        'blog_delete':host+'/blog/delete/',

        // Media Appearances
        'media_list':host+'/media_appearance/list',
        'create_media':host+'/media_appearance/create',
        'get_media_details':host+'/media_appearance/detail/slug',
        'update_media':host+'/media_appearance/update/',
        'media_delete':host+'/media_appearance/delete/',

        //Collaboration
        'collaboration_list':host+'/collaboration/list',
        'create_collaboration':host+'/collaboration/create',
        'get_collaboration_details':host+'/collaboration/getdetail/',
        'update_collaboration':host+'/collaboration/update/',
        'collaboration_delete':host+'/collaboration/delete/',

        //Publications
        'publication_list1':host+'/publication/',
        'create_publication1':host+'/publication/create',
        'get_publication_details1':host+'/publication/detail/',
        'update_publication1':host+'/publication/update/',
        'publication_delete1':host+'/publication/delete/',
        'publication_category1':host+'/publication/category/list',

        // Recents
        'recent_list':host+'/recent/list',
        'create_recent':host+'/recent/create',
        'get_recent_details':host+'/recent/getdetail/',
        'update_recent':host+'/recent/update/',
        'recent_delete':host+'/recent/delete/'
    }
};
